import React from 'react'
import AdContainer from './AdContainer'
import { useMatchScreen } from '../../context/MatchScreenContext'

interface AdSectionProps {
    adTier?: 'under25' | 'under100K'
}

const AdSection = ({
  adTier
}: AdSectionProps) => {
  const { state, dynamicTargeting } = useMatchScreen()
  const currentSavings = state?.currentSavings

  let tierName: 'under25' | 'under100K' | null = null

  if (currentSavings === '(min, 25000)') {
    tierName = adTier || 'under25'
  } else if (currentSavings === '[25000, 100000)') {
    tierName = 'under100K'
  }

  if (!tierName) {
    return null
  }

  return (
        <div>
            <AdContainer
                tierName={tierName}
                dynamicTargeting={dynamicTargeting}
            />
        </div>
  )
}

export default AdSection
